/**
 * Copyright (c) 2017 Mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 */
import { core } from './symbol-table/core';
import { structureQuery } from './symbol-table/structure-query';
import { internal } from './symbol-table/internal';
import { normalizeTable, symbolList } from './helpers';
var MolScriptSymbolTable = {
  core: core,
  structureQuery: structureQuery,
  internal: internal
};
normalizeTable(MolScriptSymbolTable);
export var SymbolList = symbolList(MolScriptSymbolTable);
export var SymbolMap = function () {
  var map = Object.create(null);

  for (var _i = 0, SymbolList_1 = SymbolList; _i < SymbolList_1.length; _i++) {
    var s = SymbolList_1[_i];
    map[s.id] = s;
  }

  return map;
}();
export { MolScriptSymbolTable };